import React from 'react';
import './Rows.less';
import ABSLink from '../../ABSLink';
import { ABSButton } from '../../ABSButton';
import ABSPerfectScrollBar from '../../ABSPerfectScrollBar';
import className from 'classnames';
export interface IRowsProps {
  list: Array<any>;
  pageSize?: any;
  renderRightContent?: (item: any, key?: number) => any;
}

export interface IRowsState {

}

class Rows extends React.Component<IRowsProps, IRowsState> {

  static defaultProps = {
    pageSize: 10
  };

  renderRightContent(item: any, key: number) {
    const { renderRightContent } = this.props;
    if (renderRightContent) {
      return renderRightContent(item, key);
    }
    const { onClick, buttonText } = item;
    return <ABSButton onClick={onClick}>{buttonText}</ABSButton>;
  }

  renderItems = (item, key, isLast) => {
    const { url = '', title = '', subTitle = '' } = item;
    const urls = url || '#';
    const clazz = className('abs-list-rows', {'abs-last-row': isLast});
    return (
      <div className={clazz}>
        <div className="abs-list-rows-item">
          <ABSLink to={urls} target="_blank" key={key}>
            <p className="abs-list-rows-item-title">{title || '-'}</p>
          </ABSLink>
          <p className="abs-list-rows-item-subTitle">{`${subTitle}`}</p>
        </div>
        {this.renderRightContent(item, key)}
      </div>
    );
  };

  renderListView() {
    const { list, pageSize } = this.props;
    return list.map((item, index) => {
      const isLast = index === (pageSize - 1);
      return this.renderItems(item, index, isLast);
    });
  }

  render() {
    return (
      <ABSPerfectScrollBar>
        <div className="abs-list">
          {this.renderListView()}
        </div>
      </ABSPerfectScrollBar>
    );
  }
}

export default Rows;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListRowsContainer/ABSRows/Rows.tsx